import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "toolbar_head_right" }
const _hoisted_2 = {
  key: 0,
  class: "userInfo"
}
const _hoisted_3 = {
  class: "name",
  style: {"color":"#878d96"}
}
const _hoisted_4 = {
  class: "name",
  style: {"margin-left":"10px","cursor":"pointer"}
}
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "line",
  style: {"margin":"0 16px"}
}, null, -1)
const _hoisted_7 = {
  class: "name",
  style: {"cursor":"pointer","flex-shrink":"0"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "切换账号", -1)
const _hoisted_9 = { class: "toolbar__switch__accounts" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "switch__accounts__svg" }

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { Check } from '@element-plus/icons-vue';
import {
  BaseDropdown,
  BaseDropdownMenu,
  BaseDropdownItem,
  useCreateModal,
  BasePopover,
  XrkMessage,
  BaseIcon
} from 'xrk-components';
import { storeToRefs } from 'pinia';

import appStore from '@/store';
import { BaseCompanyDialog } from '@/components/base/base-company/index';
import ChangePassword from './change-password.vue';
import { cutFunction } from '@/common/data-source/user/apis';
import { InvoiceEnterpriseDialog } from '@V/invoice/app';
import { useSetup } from '@/store/modules/user';
import { FunctionCode } from '@/common/types/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const { logout, initUserSystemData } = appStore.useUserStoreSetup;
const { info, userFunction, defaultUserFnName, defaultUserFnCode } =
  storeToRefs(appStore.useUserStoreSetup);
const { menuUrls } = storeToRefs(appStore.useMenuStoreSetup);

const userName = computed(() => {
  const { entpAuthStatus, phone, entpName } = info.value;
  if (+entpAuthStatus === 30) return entpName;
  return phone;
});
const entpAuthStatus = computed(() => info?.value?.entpAuthStatus);

const onCommand = e => {
  switch (e) {
    case 'info':
      useCreateModal(BaseCompanyDialog);
      break;
    case 'resetPassword':
      useCreateModal(ChangePassword, {
        onSuccess: () => {
          logout();
        }
      });
      break;
    case 'logout':
      logout();
      break;
    case 'billingMaintenance':
      useCreateModal(InvoiceEnterpriseDialog);
      break;
  }
};
const loginStore = useSetup();

const onChangeAccount = async (functionCode: FunctionCode) => {
  if (functionCode === defaultUserFnCode.value) return;

  await cutFunction({ functionCode });
  XrkMessage.success('切换成功');
  window.sessionStorage.clear();
  // 切换职能后再次请求合同拦截
  loginStore.setInfo({
    ...info.value,
    shouldShowContractSign: true
  });
  initUserSystemData(() => {
    if (entpAuthStatus.value !== 30) {
      router.replace({
        path: '/',
        query: {
          force: Date.now()
        }
      });
      return;
    }

    if (!menuUrls.value?.[0]) {
      router.replace({
        path: '/',
        query: {
          force: Date.now()
        }
      });
    } else {
      router.replace({
        path: menuUrls.value[0],
        query: {
          force: Date.now()
        }
      });
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_base_svg = _resolveComponent("base-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (entpAuthStatus.value === 30)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_base_svg, {
            iconClass: "zhanghao",
            style: {"font-size":"14px"}
          }),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(defaultUserFnName)), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(BaseDropdown), { onCommand: onCommand }, {
      dropdown: _withCtx(() => [
        _createVNode(_unref(BaseDropdownMenu), { class: "toolbar-dropdown-menu" }, {
          default: _withCtx(() => [
            (entpAuthStatus.value === 30)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_unref(BaseDropdownItem), { command: "info" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_base_svg, {
                        iconClass: "qiyexingxi",
                        className: "toolbar-item-svg"
                      }),
                      _createTextVNode(" 企业信息 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseDropdownItem), { command: "billingMaintenance" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_base_svg, {
                        iconClass: "kaipiao",
                        className: "toolbar-item-svg"
                      }),
                      _createTextVNode(" 开票维护 ")
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_unref(BaseDropdownItem), { command: "resetPassword" }, {
              default: _withCtx(() => [
                _createVNode(_component_base_svg, {
                  iconClass: "Password",
                  className: "toolbar-item-svg"
                }),
                _createTextVNode(" 重置密码 ")
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseDropdownItem), { command: "logout" }, {
              default: _withCtx(() => [
                _createVNode(_component_base_svg, {
                  iconClass: "Logout",
                  className: "toolbar-item-svg"
                }),
                _createTextVNode(" 退出登录 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            style: {"overflow":"hidden","text-overflow":"ellipsis","-webkit-box-orient":"vertical","display":"-webkit-box","line-clamp":"1","white-space":"initial","word-break":"break-all"},
            title: userName.value
          }, _toDisplayString(userName.value), 9, _hoisted_5),
          _createVNode(_component_base_svg, {
            iconClass: "zhankai",
            style: {"margin-left":"4px","font-size":"16px"}
          })
        ])
      ]),
      _: 1
    }),
    (_unref(userFunction)?.length > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_6,
          (entpAuthStatus.value === 30)
            ? (_openBlock(), _createBlock(_unref(BasePopover), {
                key: 0,
                placement: "bottom",
                trigger: "hover",
                width: 160
              }, {
                reference: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_base_svg, {
                      iconClass: "zhankai",
                      style: {"margin-left":"4px","font-size":"16px"}
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userFunction), (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["switch__accounts__item", { hover: item.functionCode !== _unref(defaultUserFnCode) }]),
                        key: index,
                        onClick: ($event: any) => (onChangeAccount(item.functionCode))
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_base_svg, {
                            iconClass: 
                  {
                    1: 'gongye2',
                    2: 'fusushang',
                    3: 'gongyingshang'
                  }[item.functionCode]
                ,
                            className: "toolbar-item-svg"
                          }, null, 8, ["iconClass"]),
                          _createElementVNode("span", null, _toDisplayString(item.functionName), 1)
                        ]),
                        (item.functionCode === _unref(defaultUserFnCode))
                          ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                              key: 0,
                              style: {"color":"#42be65"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Check))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_10))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})